import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image", "previousArrow", "nextArrow"]
  static values = {
    photoId: String
  }

  connect() {
    this.initializeLightboxState()

    // Add event listeners for Turbo navigation
    document.addEventListener('turbo:render', this.initializeLightboxState.bind(this))

    // Add keyboard navigation
    this.boundHandleKeyPress = this.handleKeyPress.bind(this)
    document.addEventListener('keydown', this.boundHandleKeyPress)
  }

  disconnect() {
    document.removeEventListener('keydown', this.boundHandleKeyPress)
    document.removeEventListener('turbo:render', this.initializeLightboxState.bind(this))
  }

  initializeLightboxState() {
    // Reset and update the lightbox state
    window.lightboxState = {
      photos: Array.from(document.querySelectorAll('.photos__item__link[data-turbo-frame="lightbox"]'))
        .map(link => ({
          id: link.dataset.photoId,
          url: link.getAttribute('href')
        }))
    }

    if (this.photoIdValue) {
      window.lightboxState.currentId = this.photoIdValue
    }

    this.updateArrows()
  }

  getCurrentIndex() {
    return window.lightboxState.photos.findIndex(photo => photo.id === this.photoIdValue)
  }

  updateArrows() {
    const currentIndex = this.getCurrentIndex()

    // Show/hide previous arrow
    if (currentIndex <= 0) {
      this.previousArrowTarget.classList.add('hidden')
    } else {
      this.previousArrowTarget.classList.remove('hidden')
    }

    // Show/hide next arrow
    if (currentIndex >= window.lightboxState.photos.length - 1) {
      this.nextArrowTarget.classList.add('hidden')
    } else {
      this.nextArrowTarget.classList.remove('hidden')
    }
  }

  previous() {
    const currentIndex = this.getCurrentIndex()
    if (currentIndex > 0) {
      const prevPhoto = window.lightboxState.photos[currentIndex - 1]
      const frame = document.querySelector('#lightbox')
      frame.setAttribute('src', prevPhoto.url)
      frame.reload()
    }
  }

  next() {
    const currentIndex = this.getCurrentIndex()
    if (currentIndex < window.lightboxState.photos.length - 1) {
      const nextPhoto = window.lightboxState.photos[currentIndex + 1]
      const frame = document.querySelector('#lightbox')
      frame.setAttribute('src', nextPhoto.url)
      frame.reload()
    }
  }

  handleKeyPress(event) {
    const target = event.target;
    const isTypingField =
      target.tagName === "INPUT" ||
      target.tagName === "TEXTAREA" ||
      target.tagName === "SELECT" ||
      target.isContentEditable;
  
    if (isTypingField) return;

    switch(event.key) {
      case 'ArrowLeft':
        this.previous()
        break
      case 'ArrowRight':
        this.next()
        break
    }
  }

  print() {
    const printWindow = window.open('', '_blank');
    const imageElement = this.imageTarget;

    printWindow.document.write(`
      <html>
        <head>
          <title>Print Photo</title>
          <style>
            body {
              margin: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              min-height: 100vh;
            }
            img {
              max-width: 100%;
              max-height: 100vh;
              object-fit: contain;
            }
          </style>
        </head>
        <body>
          <img src="${imageElement.src}" />
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  }

  toggleFullscreen() {
    if (!document.fullscreenElement) {
      this.element.requestFullscreen().catch(err => {
        console.error(`Error attempting to enable fullscreen: ${err.message}`);
      });
    } else {
      document.exitFullscreen().catch(err => {
        console.error(`Error attempting to exit fullscreen: ${err.message}`);
      });
    }
  }
}
